module.exports = __webpack_public_path__ + "img/Group 478.0c8cff58.svg";